import { defineComponent as _defineComponent } from 'vue'

import VideoExercises from '@/components/exercise/VideoExercises.vue';
import VideoCurriculums from '@/components/exercise/VideoCurriculums.vue';
import VideoSimilarContent from '@/components/videos/VideoSimilarContent.vue';
import MaterialLinks from '@/components/videos/MaterialLinks.vue';

type Props = {
  id: string;
  title: string;
  item: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {



return { __sfc: true,VideoExercises, VideoCurriculums, VideoSimilarContent, MaterialLinks }
}

})